/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';

/**
 * External dependencies
 */

/**
 * Inner dependencies.
 */
import {
	ColorControl,
} from '../../../extensions/controls/color-options';
import Accordion from '../../../components/Accordion';
import blockInfo from '../constants';
const { hookPrefix } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-style`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/style`,
	( content, props ) => {
		const { attributes, setAttributes } = props;
		const { blockAdvanceOptions } = attributes;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'colors',
						initialOpen: true,
						label: () => {
							return __( 'Colors' );
						},
						cb: () => {
							return <>
								<ColorControl
									label={ __( 'Color' ) }
									onChange={ ( color ) => {
										const data = {
											blockAdvanceOptions: {
												...blockAdvanceOptions,
												textColor: color,
											},
										};
										setAttributes( data );
									} }
									value={ blockAdvanceOptions.textColor }
								/>
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);

